import { render, staticRenderFns } from "./copyInput.vue?vue&type=template&id=b22d6c46&scoped=true"
import script from "./copyInput.vue?vue&type=script&lang=js"
export * from "./copyInput.vue?vue&type=script&lang=js"
import style0 from "./copyInput.vue?vue&type=style&index=0&id=b22d6c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22d6c46",
  null
  
)

export default component.exports